var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"back":_vm.backMenu},on:{"menuActiveUpdate":_vm.updateMenu}}),_c('router-view',{class:{'page': true, 'page--blur': _vm.blur}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }